import React, {useState} from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import Modal from '../Modal/Modal';
import Breadcrumb from "../Breadcrumb/Breadcrumb";

function Layout() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState(null);

    const openModal = (content) => {
        setModalContent(content);
        setIsModalOpen(true);
    };
    const closeModal = () => {
        setIsModalOpen(false);
        setModalContent(null);
    };

    return (
        <div className="app-container">
            <Header />
            <main>
                <Breadcrumb />

                <Outlet context={{ openModal, closeModal }} />
            </main>
            {isModalOpen && <Modal onClose={closeModal}>{modalContent}</Modal>}
            <Footer />
        </div>
    );
}

export default Layout;
